<app-title-header
  [title]="viewMode ? problemRecordIdentifier : ('title.problem_records.create_new' | translate)"
  [iconClass]="viewMode ? 'bi bi-arrow-left' : 'bi bi-pencil'"
  [iconLink]="viewMode ? backButtonLink : ''"
  [viewMode]="viewMode"
>
  @if(viewMode && problemRecordForm.dirty) {
    <ng-container *ngTemplateOutlet="submitActions; context: { isEdit: true }"></ng-container>
  }
</app-title-header>

@if(viewMode) {
  <app-tabs-with-content
    [tabs]="tabs"
    [selectedTab]="selectedTab"
    (onSelectTab)="onSelectedTab($event)"
  ></app-tabs-with-content>
}

<div [hidden]="loading">
  <div [hidden]="selectedTab !== tabs[0]">
    <div class="row">
      <form [formGroup]="problemRecordForm" class="col-12" [ngClass]="{'col-lg-8': viewMode}">

        <app-case-form-section-container
          [iconClass]="viewMode ? 'bi bi-file-earmark-text' : 'bi bi-buildings'"
          [title]="viewMode ? 'label.summary' : 'label.problem_details'"
        >
          <app-problem-record-problem-details-form
            [viewMode]="viewMode"
            [productFamilyItems]="productFamilyItems"
            [problemPriorityItems]="problemPriorityItems"
            [stageItems]="stageItems"
            [uploadedFiles]="uploadedFiles"
            [caseId]="problemRecordId"
          ></app-problem-record-problem-details-form>
        </app-case-form-section-container>

        @if(!viewMode) {
          <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.interested_parties'">
            <app-interested-parties-form [viewMode]="viewMode"></app-interested-parties-form>
          </app-case-form-section-container>

          <app-problem-records-case-records
            [productSuite]="problemRecordForm.get('productSuite')?.value"
            [productCompany]="problemRecordForm.get('productCompany')?.value"
            (newCaseRecordsEmitter)="getNewCaseRecords($event)"
            [disabled]="problemRecordForm.disabled"
          ></app-problem-records-case-records>
          }
      </form>
      <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>

    </div>

    @if(!viewMode) {
      <ng-container *ngTemplateOutlet="submitActions"></ng-container>
    }
  </div>

  <div class="row" [hidden]="selectedTab !== tabs[1]">
    <div class="col-12" [ngClass]="{'col-lg-8': viewMode}">
      <app-problem-records-case-records
        [problemRecordId]="problemRecordId"
        [productSuite]="problemRecordForm.get('productSuite')?.value"
        [productCompany]="problemRecordForm.get('productCompany')?.value"
        [disabled]="problemRecordForm.disabled"
      ></app-problem-records-case-records>
    </div>
    <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
  </div>

  <div class="row" *ngIf="selectedTab === tabs[2]">
    <div class="col-12" [ngClass]="{'col-lg-8': viewMode}">
      <app-case-history [tabs]="historyTabs" [translationPrefix]="'problemRecord.'"></app-case-history>
    </div>
    <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
  </div>


  <div class="row" *ngIf="selectedTab === tabs[3]">
    <div class="col-12" [ngClass]="{'col-lg-8': viewMode}">
      <app-case-comments [caseType]="caseType" [caseId]="problemRecordId"></app-case-comments>
    </div>
    <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
  </div>

</div>

<ng-template #formRightSidePanel>
  @if(viewMode) {
    <div class="col-12 col-lg-4">
      <form [formGroup]="problemRecordForm">
        <app-case-form-section-container [iconClass]="'bi bi-info-circle'" [title]="'label.problem_info'">
          <app-problem-record-problem-info-form
            [problemPriorityItems]="problemPriorityItems"
          ></app-problem-record-problem-info-form>
        </app-case-form-section-container>
        <app-case-form-section-container [iconClass]="'bi bi-activity'" [title]="'label.activity'">
          <app-problem-record-activity-form
            [stageItems]="stageItems"
            [problemRecordObject]="problemRecordObject"
            [nextActionValidators]="nextActionValidators"
            [problemStatus]="problemStatus"
          ></app-problem-record-activity-form>
        </app-case-form-section-container>
        <app-case-form-section-container [iconClass]="'bi bi-shield-check'" [title]="'label.owner'">
          <app-problem-record-owner-form [problemRecordObject]="problemRecordObject" (onTicketOwnerChange)="setNextActionValidators($event ? $event.id : $event)"></app-problem-record-owner-form>
        </app-case-form-section-container>
        <app-case-form-section-container [iconClass]="'bi bi-people-fill'" [title]="'label.interested_parties'">
          <app-interested-parties-form [viewMode]="viewMode"></app-interested-parties-form>
        </app-case-form-section-container>
      </form>
      <form [formGroup]="linksForm">
        <app-case-form-section-container
          [iconClass]="'bi bi-link'"
          [rightIconClass]="linksEditable ? linksEditMode ? 'bi bi-floppy2-fill text-success' : 'bi bi-pencil' : ''"
          [title]="'label.links'"
          [iconDisabled]="linksForm.invalid"
          (onClickRightIcon)="submitLinks($event)"
          >
          <app-case-links [editMode]="linksEditMode"></app-case-links>
        </app-case-form-section-container>
      </form>
    </div>
  }
</ng-template>

<ng-template #submitActions let-isEdit="isEdit">
  <div class="submit-actions problem-record-submit-actions">
    <button class="btn secondary-button" (click)="onLeaveProblemRecord()">{{ 'label.cancel' | translate }}</button>
    <button class="btn primary-button" (click)="submitForm(isEdit)" translate="{{viewMode ? 'label.update_problem_record' : 'label.create_problem_record'}}"></button>
  </div>
</ng-template>
